import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const pillFn = /* @__PURE__ */ createRecipe('pill', {}, [])

const pillVariantMap = {}

const pillVariantKeys = Object.keys(pillVariantMap)

export const pill = /* @__PURE__ */ Object.assign(memo(pillFn.recipeFn), {
  __recipe__: true,
  __name__: 'pill',
  __getCompoundVariantCss__: pillFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: pillVariantKeys,
  variantMap: pillVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, pillVariantKeys)
  },
  getVariantProps: pillFn.getVariantProps,
})